import { render, staticRenderFns } from "./WorkspaceForm.vue?vue&type=template&id=ee4093f6&scoped=true&"
import script from "./WorkspaceForm.vue?vue&type=script&lang=js&"
export * from "./WorkspaceForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceForm.scss?vue&type=style&index=0&id=ee4093f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4093f6",
  null
  
)

export default component.exports